// @ts-nocheck
/*
 * Port of views/dashboard/voice-plan/detail.js (origin/main-dev, 84 lines).
 * BYTE-IDENTICAL — canEdit derived from superadmin OR VOICE_PLANS ACL
 * edit permission, back button to LIST, VoicePlanDetailsPanel embedded.
 */
import { useEffect, useState } from 'react';
import { Card } from '@/components/ui/card';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';
import { friendlyApiError } from '@/utilities/apiErrorMessage';
import { FaArrowLeft } from 'react-icons/fa';
import { getApiCall } from '@/service/httpCall';
import { API_VOICE_PLAN_GET_BY_ID } from '@/service/url';
import { ROUTES, USER_ROLES, MODULE_ACL } from '@/utilities/constant';
import VoicePlanDetailsPanel from '@/features/voice-plan/VoicePlanDetailsPanel';
import Loader from '@/components/partials/components/Loader';
import { getUser } from '@/utilities/setting';
import { hasPermission } from '@/utilities/helpers';
import '@/features/voice-plan/voice-plan-pages.scss';
import { ScrollPage } from '@/components/layout/PageContainer';
import { PageHeader } from '@/components/feedback/PageHeader';
import { Button as PageButton } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { parseModuleOperations } from '@/utilities/voicePlanAcl';

export default function VoicePlanDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [plan, setPlan] = useState(null);
  const [canEdit, setCanEdit] = useState(false);

  useEffect(() => {
    const user = getUser();
    const superAdmin = user?.role === USER_ROLES.SUPERADMIN;
    let ops = {};
    try {
      ops = user?.acl_settings?.module_operations
        ? typeof user.acl_settings.module_operations === 'string'
          ? parseModuleOperations(user.acl_settings.module_operations)
          : user.acl_settings.module_operations
        : {};
    } catch {
      ops = {};
    }
    const aclLoaded = Object.keys(ops).length > 0;
    setCanEdit(superAdmin || !aclLoaded || hasPermission(ops, MODULE_ACL.VOICE_PLANS, 'edit'));

    getApiCall(`${API_VOICE_PLAN_GET_BY_ID}/${id}`)
      .then((resp) => setPlan(resp))
      .catch(() => toast.error('Failed to load voice plan'))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Loader />;

  if (!plan) {
    return <div className="vp-detail-page p-4 text-center">Voice plan not found.</div>;
  }

  return (
    <ScrollPage>
      <PageHeader
        title="Voice Plan Details"
        description={plan.plan_name || 'View voice plan configuration.'}
        actions={
          <PageButton
            variant="outline"
            size="sm"
            onClick={() => navigate(`/${ROUTES.VOICE_PLAN.LIST}`)}
            className="gap-1"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to Voice Plans
          </PageButton>
        }
      />
      <div className="vp-detail-page">
        <Card>
          <div className="p-0">
            <VoicePlanDetailsPanel plan={plan} enabled={plan.plan_status == 1} canEdit={canEdit} />
          </div>
        </Card>
      </div>
    </ScrollPage>
  );
}
